import React, { useEffect, useState } from 'react';
import { Check, Star, Clock, AlertTriangle, ShieldCheck, ArrowRight, Menu, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Accordion } from '../components/ui/Accordion';
import { SalesPopup } from '../components/SalesPopup';
import { PixelTracker } from '../components/PixelTracker';
// Images
const IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/eFsH9MiZ37UKZeqQnDChNj/mocap_pasteleria.png',
  bono1: 'https://cdn.magicpatterns.com/uploads/niNbwmfaz6frkNS3YgnATj/mocap_bono_1.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/qPkY6DaztduWFXBhcYSuDM/mocap_bono_2.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/bSLuWY4XC7CYVqrZRqxSbN/mocap_bono_3.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/v8tmoymo72A91sPabtXqFd/mocap_bono_4.png'
};
const CHECKOUT_URL = 'https://checkout.descargatop.com/cart/40923243511857:1';
export function LandingPage() {
  // Countdown Timer Logic
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 42
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  const handleBuyClick = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-20" data-id="element-19">
      <PixelTracker data-id="element-20" />
      <SalesPopup data-id="element-21" />

      {/* 1. Top Bar */}
      <div className="bg-[#cc0000] text-white text-center py-3 px-4 font-bold text-sm md:text-base sticky top-0 z-40 shadow-md" data-id="element-22">
        <div className="flex items-center justify-center gap-2 animate-pulse" data-id="element-23">
          <Clock className="w-5 h-5" data-id="element-24" />
          <span data-id="element-25">
            OFERTA EXPIRA EN: {formatTime(timeLeft.hours)}:
            {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)} | SOLO
            QUEDAN 5 CUPOS
          </span>
        </div>
      </div>

      {/* Main Container */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-26">
        {/* 2. Hero Section */}
        <section className="py-8 md:py-12 text-center" data-id="element-27">
          <p className="text-[#cc0000] font-bold tracking-wider uppercase mb-4 text-sm md:text-base" data-id="element-28">
            🐶 MEGAPACK PASTELERÍA Y NUTRICIÓN CANINA
          </p>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 text-gray-900" data-id="element-29">
            Emprende • Alimenta Mejor •{' '}
            <span className="text-[#ff9900]" data-id="element-30">Genera Ingresos</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-2xl mx-auto font-medium" data-id="element-31">
            Recetas reales. Nutrición responsable. Un negocio desde casa.
          </p>

          <div className="bg-yellow-50 border-l-4 border-[#ff9900] p-4 mb-8 text-left max-w-2xl mx-auto" data-id="element-32">
            <p className="font-semibold text-gray-800" data-id="element-33">
              Aprendé paso a paso cómo preparar alimentos saludables para perros
              y convertirlo en una fuente de ingresos.
            </p>
          </div>

          <div className="mb-10" data-id="element-34">
            <img src={IMAGES.main} alt="Megapack Pastelería Canina" className="w-full max-w-2xl mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-35" />
          </div>

          <Button variant="primary" size="xl" onClick={handleBuyClick} className="w-full md:w-auto animate-bounce-slow" data-id="element-36">
            👉 SÍ, QUIERO ACCEDER AHORA
          </Button>

          <div className="mt-4 flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-37">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-38" />
            <span data-id="element-39">Garantía de satisfacción de 7 días</span>
          </div>
        </section>

        {/* 3. Agitation Section */}
        <section className="py-12 border-t border-gray-100" data-id="element-40">
          <div className="prose prose-lg mx-auto text-gray-700" data-id="element-41">
            <p className="font-bold text-xl text-gray-900" data-id="element-42">
              Si amas a tu perro o quieres emprender desde casa, dejame hacerte
              una pregunta honesta…
            </p>

            <ul className="space-y-4 list-none pl-0 my-8" data-id="element-43">
              <li className="flex gap-3 items-start" data-id="element-44">
                <AlertTriangle className="w-6 h-6 text-[#cc0000] flex-shrink-0 mt-1" data-id="element-45" />
                <span data-id="element-46">
                  ¿Te frustra no saber exactamente qué está comiendo tu mascota?
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-47">
                <AlertTriangle className="w-6 h-6 text-[#cc0000] flex-shrink-0 mt-1" data-id="element-48" />
                <span data-id="element-49">
                  ¿Te gustaría generar ingresos extra pero no sabes por dónde
                  empezar?
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-50">
                <AlertTriangle className="w-6 h-6 text-[#cc0000] flex-shrink-0 mt-1" data-id="element-51" />
                <span data-id="element-52">
                  ¿Sientes que podrías hacer algo más… si tuvieras una guía
                  clara y paso a paso?
                </span>
              </li>
            </ul>

            <p data-id="element-53">
              No porque no quieras. No porque no tengas talento. <br data-id="element-54" />
              <span className="font-bold" data-id="element-55">
                Sino porque nadie te enseñó cómo hacerlo correctamente.
              </span>
            </p>

            <p className="bg-gray-100 p-4 rounded-lg border-l-4 border-gray-400 italic" data-id="element-56">
              Y mientras tanto… <br data-id="element-57" />
              Tu perro sigue comiendo productos industriales. <br data-id="element-58" />Y tú sigues
              postergando esa idea de emprender desde casa.
            </p>

            <h3 className="text-2xl font-bold text-[#cc0000] mt-12 mb-6 text-center" data-id="element-59">
              El problema que nadie dice en voz alta
            </h3>

            <p data-id="element-60">Si esto te pasa, no estás sola/o:</p>

            <div className="grid md:grid-cols-2 gap-4 my-6" data-id="element-61">
              {['Compras snacks sin saber realmente qué contienen', 'Quieres emprender pero no sabes qué vender', 'Te preocupa la salud de tu mascota', 'No sabes cómo calcular precios', 'Tienes miedo de hacerlo mal'].map((item, i) => <div key={i} className="flex items-center gap-2 text-gray-700" data-id="element-62">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-63" />
                  <span data-id="element-64">{item}</span>
                </div>)}
            </div>

            <p className="text-center font-bold text-lg mt-8" data-id="element-65">
              Y aparece ese pensamiento incómodo: <br data-id="element-66" />
              <span className="text-2xl block mt-2 font-extrabold text-gray-900" data-id="element-67">
                "Si tuviera una guía clara… lo intentaría."
              </span>
            </p>
          </div>
        </section>

        {/* 4. Solution Section */}
        <section className="py-12 bg-green-50 -mx-4 sm:-mx-6 md:-mx-8 px-4 sm:px-6 md:px-8" data-id="element-68">
          <div className="max-w-4xl mx-auto text-center" data-id="element-69">
            <h2 className="text-3xl font-extrabold text-green-700 mb-8" data-id="element-70">
              ✅ La solución
            </h2>
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-71">
              🐶 MEGAPACK PASTELERÍA Y NUTRICIÓN CANINA
            </h3>

            <p className="text-lg text-gray-700 mb-8" data-id="element-72">
              Un sistema completo que te enseña:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto mb-10 text-left" data-id="element-73">
              {['Nutrición canina desde cero', 'Recetas saludables paso a paso', 'Adaptación para alergias e intolerancias', 'Técnicas profesionales', 'Cómo vender y generar ingresos'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-74">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-75" />
                  <span className="font-semibold text-gray-800" data-id="element-76">{item}</span>
                </div>)}
            </div>

            <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-xl font-bold text-gray-800 mb-10" data-id="element-77">
              <div className="flex flex-col items-center" data-id="element-78">
                <span className="text-4xl mb-2" data-id="element-79">📖</span>
                <span data-id="element-80">Abrís el Megapack</span>
              </div>
              <ArrowRight className="hidden md:block text-gray-400" data-id="element-81" />
              <div className="flex flex-col items-center" data-id="element-82">
                <span className="text-4xl mb-2" data-id="element-83">👩‍🍳</span>
                <span data-id="element-84">Preparás las recetas</span>
              </div>
              <ArrowRight className="hidden md:block text-gray-400" data-id="element-85" />
              <div className="flex flex-col items-center" data-id="element-86">
                <span className="text-4xl mb-2" data-id="element-87">💰</span>
                <span data-id="element-88">Comenzás a vender</span>
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-4 text-sm font-semibold text-gray-500 uppercase tracking-wide" data-id="element-89">
              <span data-id="element-90">Sin experiencia previa</span> •
              <span data-id="element-91">Sin cursos costosos</span> •<span data-id="element-92">Sin salir de casa</span>
            </div>
          </div>
        </section>

        {/* 5. Product Modules */}
        <section className="py-16" data-id="element-93">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center text-gray-900 mb-12" data-id="element-94">
            📚 ¿Qué incluye exactamente el Megapack?
          </h2>

          <div className="bg-blue-50 p-6 rounded-xl border-2 border-blue-100 mb-12" data-id="element-95">
            <h3 className="text-2xl font-bold text-blue-800 mb-6 text-center" data-id="element-96">
              📘 6 TOMOS PROFESIONALES
            </h3>
            <div className="space-y-6" data-id="element-97">
              {[{
              title: 'Tomo 1 – Fundamentos de Nutrición y Salud Canina',
              desc: 'Aprende cómo funciona la alimentación canina y cómo crear recetas equilibradas.'
            }, {
              title: 'Tomo 2 – Panadería y Snacks Caninos',
              desc: 'Galletas, panecillos y productos horneados fáciles y vendibles.'
            }, {
              title: 'Tomo 3 – Snacks Funcionales y Naturales',
              desc: 'Recetas que aportan beneficios digestivos, energéticos y de bienestar.'
            }, {
              title: 'Tomo 4 – Pasteles y Celebraciones Caninas',
              desc: 'Tortas y productos premium para cumpleaños y eventos.'
            }, {
              title: 'Tomo 5 – Helados y Recetas Refrescantes',
              desc: 'Opciones innovadoras para diferenciarte en el mercado.'
            }, {
              title: 'Tomo 6 – Emprendimiento en Pastelería Canina',
              desc: 'Cómo calcular precios, presentar productos y generar ingresos reales.'
            }].map((tomo, i) => <div key={i} className="flex gap-4 items-start" data-id="element-98">
                  <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 font-bold mt-1" data-id="element-99">
                    {i + 1}
                  </div>
                  <div data-id="element-100">
                    <h4 className="font-bold text-lg text-gray-900" data-id="element-101">
                      {tomo.title}
                    </h4>
                    <p className="text-gray-600" data-id="element-102">{tomo.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* 6. Bonuses */}
        <section className="py-12" data-id="element-103">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center text-[#cc0000] mb-4" data-id="element-104">
            🎁 BONOS INCLUIDOS HOY
          </h2>
          <p className="text-center text-gray-500 mb-12 uppercase tracking-widest font-bold" data-id="element-105">
            (Sin costo adicional)
          </p>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-106">
            {[{
            img: IMAGES.bono1,
            title: 'Bono #1 – Nutrición y Pastelería Felina',
            desc: 'Amplía tu mercado aprendiendo también recetas para gatos.'
          }, {
            img: IMAGES.bono2,
            title: 'Bono #2 – Dieta BARF Paso a Paso',
            desc: 'Aprende alimentación natural correctamente y sin riesgos.'
          }, {
            img: IMAGES.bono3,
            title: 'Bono #3 – Guía para Prevenir Enfermedades en Casa',
            desc: 'Cómo cuidar la salud de tu perro desde casa.'
          }, {
            img: IMAGES.bono4,
            title: 'Bono #4 – Cachorro en Casa',
            desc: 'Crianza, alimentación y entrenamiento desde el primer día.'
          }].map((bono, i) => <div key={i} className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow" data-id="element-107">
                <div className="bg-gray-50 p-4 flex justify-center" data-id="element-108">
                  <img src={bono.img} alt={bono.title} className="h-64 object-contain" data-id="element-109" />
                </div>
                <div className="p-6" data-id="element-110">
                  <span className="bg-green-100 text-green-800 text-xs font-bold px-2 py-1 rounded uppercase mb-2 inline-block" data-id="element-111">
                    Gratis Hoy
                  </span>
                  <h3 className="font-bold text-xl text-gray-900 mb-2" data-id="element-112">
                    {bono.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-113">{bono.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="text-center mt-12" data-id="element-114">
            <p className="text-2xl font-bold text-gray-800" data-id="element-115">
              👉 6 Tomos + 4 Bonos en un solo Megapack.
            </p>
          </div>
        </section>

        {/* 7. Before vs After */}
        <section className="py-12 border-t border-b border-gray-100 bg-gray-50 -mx-4 sm:-mx-6 md:-mx-8 px-4 sm:px-6 md:px-8" data-id="element-116">
          <div className="max-w-4xl mx-auto" data-id="element-117">
            <h2 className="text-3xl font-extrabold text-center mb-10" data-id="element-118">
              🔄 Antes vs Después
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-119">
              <div className="bg-white p-8 rounded-xl shadow-sm border-t-4 border-red-500" data-id="element-120">
                <h3 className="text-xl font-bold text-red-600 mb-6 flex items-center gap-2" data-id="element-121">
                  <X className="w-6 h-6" data-id="element-122" /> Antes del Megapack
                </h3>
                <ul className="space-y-4" data-id="element-123">
                  {['No sabes qué ingredientes usar', 'Compras snacks industriales', 'No tienes ingresos extra', 'Tienes dudas sobre la nutrición', 'Postergas la idea de emprender'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-600" data-id="element-124">
                      <X className="w-5 h-5 text-red-400 mt-0.5 flex-shrink-0" data-id="element-125" />
                      <span data-id="element-126">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-green-500 transform md:-translate-y-4" data-id="element-127">
                <h3 className="text-xl font-bold text-green-600 mb-6 flex items-center gap-2" data-id="element-128">
                  <Check className="w-6 h-6" data-id="element-129" /> Después del Megapack
                </h3>
                <ul className="space-y-4" data-id="element-130">
                  {['Preparas alimentos saludables', 'Sabes exactamente qué estás usando', 'Generas ingresos desde casa', 'Te diferencias con productos premium', 'Confianza para vender'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-800 font-medium" data-id="element-131">
                      <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-132" />
                      <span data-id="element-133">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* 8. Stack/Offer Summary */}
        <section className="py-16" data-id="element-134">
          <div className="bg-gray-900 text-white rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-135">
            <h2 className="text-3xl md:text-4xl font-extrabold text-center text-yellow-400 mb-10" data-id="element-136">
              🎁 ¿Qué vas a recibir hoy?
            </h2>

            <div className="grid md:grid-cols-2 gap-x-12 gap-y-4 max-w-2xl mx-auto" data-id="element-137">
              {['6 libros principales', '4 bonos exclusivos', 'Recetas paso a paso', 'Formación en nutrición', 'Formación en emprendimiento', 'Formato PDF (celular, tablet, PC)', 'Podés imprimirlo', 'Acceso inmediato', 'Un solo pago'].map((item, i) => <div key={i} className="flex items-center gap-3 border-b border-gray-700 pb-2" data-id="element-138">
                  <Check className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-139" />
                  <span className="text-lg" data-id="element-140">{item}</span>
                </div>)}
            </div>

            {/* 9. Pricing */}
            <div className="mt-12 text-center bg-white text-gray-900 rounded-xl p-8 max-w-lg mx-auto" data-id="element-141">
              <p className="text-gray-500 text-lg mb-2" data-id="element-142">
                Precio regular del contenido completo:
              </p>
              <p className="text-2xl text-red-500 line-through font-bold mb-6" data-id="element-143">
                USD $45
              </p>

              <div className="bg-yellow-100 inline-block px-6 py-2 rounded-full mb-4" data-id="element-144">
                <span className="text-yellow-800 font-bold tracking-wider" data-id="element-145">
                  🔥 HOY SOLO
                </span>
              </div>

              <p className="text-6xl md:text-7xl font-extrabold text-gray-900 mb-4" data-id="element-146">
                USD $12.99
              </p>

              <div className="flex flex-col gap-1 text-sm text-gray-500 mb-8" data-id="element-147">
                <span data-id="element-148">Pagás en la moneda de tu país</span>
                <span data-id="element-149">Descarga digital inmediata</span>
              </div>

              <Button variant="primary" size="xl" fullWidth onClick={handleBuyClick} className="animate-pulse" data-id="element-150">
                👉 QUIERO EL MEGAPACK AHORA
              </Button>
            </div>
          </div>
        </section>

        {/* 10. Guarantee */}
        <section className="py-12 max-w-2xl mx-auto text-center" data-id="element-151">
          <div className="border-4 border-dashed border-gray-300 rounded-xl p-8" data-id="element-152">
            <ShieldCheck className="w-16 h-16 text-green-500 mx-auto mb-4" data-id="element-153" />
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-154">
              🔒 Garantía sin riesgo
            </h2>
            <p className="text-lg text-gray-700 mb-4" data-id="element-155">
              Probalo durante 7 días. Si no es para vos, te devolvemos el 100%
              del dinero.
            </p>
            <p className="font-bold text-gray-900" data-id="element-156">
              Sin preguntas. Sin letra chica.
            </p>
          </div>
        </section>

        {/* 11. Testimonials */}
        <section className="py-12 bg-gray-50 -mx-4 sm:-mx-6 md:-mx-8 px-4 sm:px-6 md:px-8" data-id="element-157">
          <div className="max-w-4xl mx-auto" data-id="element-158">
            <h2 className="text-3xl font-extrabold text-center mb-12" data-id="element-159">
              💬 Lo que dicen nuestras alumnas
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-160">
              {[{
              quote: 'Empecé preparando para mi perro… ahora vendo todas las semanas.',
              author: 'Laura, emprendedora'
            }, {
              quote: 'No sabía nada de nutrición. Ahora preparo todo en casa con seguridad.',
              author: 'Mariana, mamá perruna'
            }, {
              quote: 'En 2 semanas recuperé la inversión.',
              author: 'Carla, pastelería casera'
            }, {
              quote: 'No es solo un recetario, es un negocio.',
              author: 'Andrea'
            }].map((t, i) => <div key={i} className="bg-white p-6 rounded-lg shadow-sm" data-id="element-161">
                  <div className="flex text-yellow-400 mb-3" data-id="element-162">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-163" />)}
                  </div>
                  <p className="text-gray-700 italic mb-4" data-id="element-164">"{t.quote}"</p>
                  <p className="font-bold text-gray-900 text-sm" data-id="element-165">
                    — {t.author}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* 12. FAQ */}
        <section className="py-16 max-w-3xl mx-auto" data-id="element-166">
          <h2 className="text-3xl font-extrabold text-center mb-10" data-id="element-167">
            ❓ Preguntas frecuentes
          </h2>
          <Accordion items={[{
          title: '¿Es material digital?',
          content: 'Sí, se entrega en PDF y llega al instante a tu correo electrónico.'
        }, {
          title: '¿Necesito experiencia previa?',
          content: 'No, está diseñado para principiantes con instrucciones paso a paso.'
        }, {
          title: '¿Puedo vender lo que aprenda?',
          content: 'Sí, el Megapack incluye un módulo completo de emprendimiento para que inicies tu negocio.'
        }, {
          title: '¿Sirve si mi perro tiene alergias?',
          content: 'Sí, incluye adaptación de recetas para perros con alergias e intolerancias alimentarias.'
        }]} data-id="element-168" />
        </section>

        {/* Final CTA */}
        <section className="py-16 text-center" data-id="element-169">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-170">
            🐶 La salud de tu perro no se improvisa
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-171">
            Y tu emprendimiento tampoco.
          </p>

          <div className="bg-gray-100 inline-block px-6 py-3 rounded-lg mb-8" data-id="element-172">
            <p className="font-semibold text-gray-800" data-id="element-173">
              No necesitás más tiempo. Necesitás el sistema correcto.
            </p>
          </div>

          <div className="max-w-md mx-auto" data-id="element-174">
            <Button variant="primary" size="xl" fullWidth onClick={handleBuyClick} data-id="element-175">
              👉 Accedé ahora al MEGAPACK
            </Button>
          </div>
        </section>

        {/* 13. Footer */}
        <footer className="py-8 text-center text-gray-500 text-sm border-t border-gray-200" data-id="element-176">
          <p className="mb-2" data-id="element-177">
            © 2026 DescargaTop – Megapack Pastelería y Nutrición Canina
          </p>
          <p data-id="element-178">
            Todos los derechos reservados | Privacidad · Términos y Condiciones
          </p>
        </footer>
      </div>
    </div>;
}